import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import LoginPage from './pages/LoginPage';

/**
 * Check if JWT token is valid and not expired.
 */
function isTokenValid(token) {
  if (!token) return false;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (payload.length % 4 !== 0) payload += '=';
    const decoded = JSON.parse(atob(payload));
    // Check expiry with 30s buffer
    if (decoded.exp && decoded.exp * 1000 < Date.now() - 30000) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('keycloak_token');

  if (!isTokenValid(token)) {
    // Clear stale tokens
    localStorage.removeItem('keycloak_token');
    localStorage.removeItem('keycloak_refresh_token');
    return <Navigate to="/login" replace />;
  }

  return children;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        }
      />
    </Routes>
  </BrowserRouter>
);
